import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { AdType } from '../components/ads-banners/ads-banners.component';
import { isPlatformBrowser } from '@angular/common';
import { LandingModelService } from './landingModel.service';

declare var window: any;
declare var googletag: any;

@Injectable({
  providedIn: 'root',
})

export class AdsBannersService {
  private alreadyLoaded: boolean = false;

  regularTypes: AdType[][] = [
    [AdType.REGULAR1, AdType.REGULAR2],
    [AdType.REGULAR3, AdType.REGULAR4],
    [AdType.REGULAR5, AdType.REGULAR6],
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private landingModelService: LandingModelService
  ) {
    this.enableLazyLoading();
  }

  initAds(){
    this.regularTypes = [
      [AdType.REGULAR1, AdType.REGULAR2],
      [AdType.REGULAR3, AdType.REGULAR4],
      [AdType.REGULAR5, AdType.REGULAR6],
    ];
    this.destroyPreviousSlots();
  }

  resolveRegularType(): AdType[] {
    return this.regularTypes.splice(0, 1)[0];
  }

  loadGoogleTagManager() {
    if (isPlatformBrowser(this.platformId) && !this.alreadyLoaded && !window.googletag?.apiReady) {
      this.alreadyLoaded = true;
      const script = document.createElement('script');
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }

  enableLazyLoading() {
    let googleAdsData = this.landingModelService.getLandingModel().googleAds;
    if (googleAdsData?.enabled && isPlatformBrowser(this.platformId)) {

      window.googletag = window.googletag || {cmd: []};
      window.googletag.cmd = window.googletag.cmd || [];

      window.googletag.cmd?.push(function() {
        window.googletag
          .pubads()
          .enableLazyLoad({
            fetchMarginPercent: 120,  // Fetch slots within 1,2 viewport.
            renderMarginPercent: 120, // Render slots within ,2 viewport.
            mobileScaling: 1.5
          });
      });
    }
  }

  destroyPreviousSlots(){
    if (window.googletag?.cmd && typeof window.googletag.destroySlots === "function") {
      window.googletag.cmd.push( (slots) => {
        window.googletag.destroySlots(slots);
      });
    }
  }

}
